const fontsUrl = "https://assets.climatepartner.com/latest/fonts";
export const fontFaceIBMPlexSans = [
    {
        "@font-face": {
            fontFamily: "IBM Plex Sans",
            src: `local('IBM Plex Sans SemiBold Italic'), local('IBMPlexSans-SemiBoldItalic'),
            url('${fontsUrl}/IBMPlexSans/IBMPlexSans-SemiBoldItalic.woff2') format('woff2'),
            url('${fontsUrl}/IBMPlexSans/IBMPlexSans-SemiBoldItalic.woff') format('woff')`,
            fontWeight: "600",
            fontStyle: "italic",
            fontDisplay: "swap",
        },
    },
    {
        "@font-face": {
            fontFamily: "IBM Plex Sans",
            src: `local('IBM Plex Sans Light Italic'), local('IBMPlexSans-LightItalic'),
            url('${fontsUrl}/IBMPlexSans/IBMPlexSans-LightItalic.woff2') format('woff2'),
            url('${fontsUrl}/IBMPlexSans/IBMPlexSans-LightItalic.woff') format('woff')`,
            fontWeight: "300",
            fontStyle: "italic",
            fontDisplay: "swap",
        },
    },
    {
        "@font-face": {
            fontFamily: "IBM Plex Sans",
            src: `local('IBM Plex Sans Thin'), local('IBMPlexSans-Thin'),
            url('${fontsUrl}/IBMPlexSans/IBMPlexSans-Thin.woff2') format('woff2'),
            url('${fontsUrl}/IBMPlexSans/IBMPlexSans-Thin.woff') format('woff')`,
            fontWeight: "100",
            fontStyle: "normal",
            fontDisplay: "swap",
        },
    },
    {
        "@font-face": {
            fontFamily: "IBM Plex Sans",
            src: `local('IBM Plex Sans ExtraLight Italic'), local('IBMPlexSans-ExtraLightItalic'),
            url('${fontsUrl}/IBMPlexSans/IBMPlexSans-ExtraLightItalic.woff2') format('woff2'),
            url('${fontsUrl}/IBMPlexSans/IBMPlexSans-ExtraLightItalic.woff') format('woff')`,
            fontWeight: "200",
            fontStyle: "italic",
            fontDisplay: "swap",
        },
    },
    {
        "@font-face": {
            fontFamily: "IBM Plex Sans",
            src: `local('IBM Plex Sans Bold'), local('IBMPlexSans-Bold'),
            url('${fontsUrl}/IBMPlexSans/IBMPlexSans-Bold.woff2') format('woff2'),
            url('${fontsUrl}/IBMPlexSans/IBMPlexSans-Bold.woff') format('woff')`,
            fontWeight: "bold",
            fontStyle: "normal",
            fontDisplay: "swap",
        },
    },
    {
        "@font-face": {
            fontFamily: "IBM Plex Sans",
            src: `local('IBM Plex Sans Medium'), local('IBMPlexSans-Medium'),
            url('${fontsUrl}/IBMPlexSans/IBMPlexSans-Medium.woff2') format('woff2'),
            url('${fontsUrl}/IBMPlexSans/IBMPlexSans-Medium.woff') format('woff')`,
            fontWeight: "500",
            fontStyle: "normal",
            fontDisplay: "swap",
        },
    },
    {
        "@font-face": {
            fontFamily: "IBM Plex Sans",
            src: `local('IBM Plex Sans Light'), local('IBMPlexSans-Light'),
            url('${fontsUrl}/IBMPlexSans/IBMPlexSans-Light.woff2') format('woff2'),
            url('${fontsUrl}/IBMPlexSans/IBMPlexSans-Light.woff') format('woff')`,
            fontWeight: "300",
            fontStyle: "normal",
            fontDisplay: "swap",
        },
    },
    {
        "@font-face": {
            fontFamily: "IBM Plex Sans",
            src: `local('IBM Plex Sans Medium Italic'), local('IBMPlexSans-MediumItalic'),
            url('${fontsUrl}/IBMPlexSans/IBMPlexSans-MediumItalic.woff2') format('woff2'),
            url('${fontsUrl}/IBMPlexSans/IBMPlexSans-MediumItalic.woff') format('woff')`,
            fontWeight: "500",
            fontStyle: "italic",
            fontDisplay: "swap",
        },
    },
    {
        "@font-face": {
            fontFamily: "IBM Plex Sans",
            src: `local('IBM Plex Sans Italic'), local('IBMPlexSans-Italic'),
            url('${fontsUrl}/IBMPlexSans/IBMPlexSans-Italic.woff2') format('woff2'),
            url('${fontsUrl}/IBMPlexSans/IBMPlexSans-Italic.woff') format('woff')`,
            fontWeight: "normal",
            fontStyle: "italic",
            fontDisplay: "swap",
        },
    },
    {
        "@font-face": {
            fontFamily: "IBM Plex Sans",
            src: `local('IBM Plex Sans Thin Italic'), local('IBMPlexSans-ThinItalic'),
            url('${fontsUrl}/IBMPlexSans/IBMPlexSans-ThinItalic.woff2') format('woff2'),
            url('${fontsUrl}/IBMPlexSans/IBMPlexSans-ThinItalic.woff') format('woff')`,
            fontWeight: "100",
            fontStyle: "italic",
            fontDisplay: "swap",
        },
    },
    {
        "@font-face": {
            fontFamily: "IBM Plex Sans",
            src: `local('IBM Plex Sans ExtraLight'), local('IBMPlexSans-ExtraLight'),
            url('${fontsUrl}/IBMPlexSans/IBMPlexSans-ExtraLight.woff2') format('woff2'),
            url('${fontsUrl}/IBMPlexSans/IBMPlexSans-ExtraLight.woff') format('woff')`,
            fontWeight: "200",
            fontStyle: "normal",
            fontDisplay: "swap",
        },
    },
    {
        "@font-face": {
            fontFamily: "IBM Plex Sans",
            src: `local('IBM Plex Sans SemiBold'), local('IBMPlexSans-SemiBold'),
            url('${fontsUrl}/IBMPlexSans/IBMPlexSans-SemiBold.woff2') format('woff2'),
            url('${fontsUrl}/IBMPlexSans/IBMPlexSans-SemiBold.woff') format('woff')`,
            fontWeight: "600",
            fontStyle: "normal",
            fontDisplay: "swap",
        },
    },
    {
        "@font-face": {
            fontFamily: "IBM Plex Sans",
            src: `local('IBM Plex Sans Bold Italic'), local('IBMPlexSans-BoldItalic'),
            url('${fontsUrl}/IBMPlexSans/IBMPlexSans-BoldItalic.woff2') format('woff2'),
            url('${fontsUrl}/IBMPlexSans/IBMPlexSans-BoldItalic.woff') format('woff')`,
            fontWeight: "bold",
            fontStyle: "italic",
            fontDisplay: "swap",
        },
    },
    {
        "@font-face": {
            fontFamily: "IBM Plex Sans",
            src: `local('IBM Plex Sans Regular'), local('IBMPlexSans-Regular'),
            url('${fontsUrl}/IBMPlexSans/IBMPlexSans-Regular.woff2') format('woff2'),
            url('${fontsUrl}/IBMPlexSans/IBMPlexSans-Regular.woff') format('woff')`,
            fontWeight: "normal",
            fontStyle: "normal",
            fontDisplay: "swap",
        },
    },
];
//# sourceMappingURL=fontFace.js.map